import { Fragment, useState } from 'react'
import { Disclosure, Menu, Popover, Transition, Dialog } from '@headlessui/react'
import {
  XIcon
} from '@heroicons/react/outline'

import { useUser } from '../providers/UserProvider'
import { useNotification } from '../providers/NotificationProvider'
import UserService from '../services/UserService'

const formClass = "appearance-none block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 font-primary text-login-form-input";

const Seperator = () => {
  return (
    <div className="w-full border-t border-gray-300" />
  )
}

const ProfileForm = () => {
  const [ user, userDispatch ] = useUser();

  const [ formData, setFormData ] = useState({
    name: user.profile.name,
    business: user.profile.business,
    email: user.profile.email,
    password: "Reset Password",
    showName: false,
    showBusiness: false,
    showEmail: false,
    showPassword: false
  });

  const initiateResetPassword = (evt) => {
    evt.preventDefault();
    UserService.forgotPassword(user.profile.email);
    setFormData({
      ...formData,
      password: "Password Reset Sent."
    });
  }

  const updateUser = (evt) => {
    evt.preventDefault();
    let newUser = {
      ...user.profile,
      name: formData.name,
      business: formData.business,
      email: formData.email,
    }
    UserService.updateUser(newUser, user.token).then((response) => {
      let updateUser = response.data.data.updateUser;
      if (updateUser.success === true) {
        userDispatch({ type: "user/update", payload: { user: updateUser.user } });
        setFormData({ ...formData, showName: false, showEmail: false, showBusiness: false });
      } else {

      }

    }).catch(() => {

    });
  }

  return (
    <div className="space-y-8 xl:space-y-4 mt-6">
      {/* Email */}
      {/*
      <div className="lg:grid lg:grid-cols-3 lg:gap-2 items-center">
        <div className="lg:col-span-1">
          <h3 className="font-primary text-profile-settings-label-mobile lg:text-profile-settings-label leading-6">Email</h3>
        </div>
        <div className="lg:col-span-2">
          <div className="col-span-6 xl:col-span-3">
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              disabled
              onChange={(e) => {
                setFormData({
                  ...formData,
                  email: e.target.value,
                  showEmail: true
                });
              }}
              className={formClass}
            />
          </div>
        </div>

        <Transition.Root show={formData.showEmail} as="div" className="col-span-3 flex justify-end">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
              <div className="col-span-6 xl:col-span-3">
                <button type="button" className="mr-4" onClick={() => {
                  setFormData({
                    ...formData,
                    email: user.profile.email,
                    showEmail: false
                  });
                }}
                >Cancel</button>
                <button type="button" className="">Save Changes</button>
              </div>
          </Transition.Child>
        </Transition.Root>
      </div>
      */}
      {/* End Business */}

      {/* Name */}
      <div className="lg:grid lg:grid-cols-3 lg:gap-2 items-center">
        <div className="lg:col-span-1">
          <h3 className="font-primary text-profile-settings-label-mobile lg:text-profile-settings-label leading-6">Full Name</h3>
        </div>
        <div className="lg:col-span-2">
          <div className="col-span-6 xl:col-span-3">
            <input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  name: e.target.value,
                  showName: true
                });
              }}
              className={formClass}
            />
          </div>
        </div>

        <Transition.Root show={formData.showName} as="div" className="col-span-3 flex justify-end">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
              <div className="col-span-6 xl:col-span-3">
                <button type="button" className="mr-4" onClick={() => {
                  setFormData({
                    ...formData,
                    name: user.profile.name,
                    showName: false
                  });
                }}
                >Cancel</button>
                <button 
                  type="button" 
                  className=""
                  onClick={updateUser}
                >
                  Save Changes
                </button>
              </div>
          </Transition.Child>
        </Transition.Root>
      </div>
      {/* End Name */}

      {/* Business */}
      <div className="lg:grid lg:grid-cols-3 lg:gap-2 items-center">
        <div className="lg:col-span-1">
          <h3 className="font-primary text-profile-settings-label-mobile lg:text-profile-settings-label leading-6">Business</h3>
        </div>
        <div className="lg:col-span-2">
          <div className="col-span-6 xl:col-span-3">
            <input
              type="text"
              name="business"
              id="business"
              value={formData.business}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  business: e.target.value,
                  showBusiness: true
                });
              }}
              className={formClass}
            />
          </div>
        </div>

        <Transition.Root show={formData.showBusiness} as="div" className="col-span-3 flex justify-end">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
              <div className="col-span-6 xl:col-span-3">
                <button type="button" className="mr-4" onClick={() => {
                  setFormData({
                    ...formData,
                    name: user.profile.business,
                    showBusiness: false
                  });
                }}
                >Cancel</button>
                <button onClick={updateUser} type="button" className="">Save Changes</button>
              </div>
          </Transition.Child>
        </Transition.Root>
      </div>
      {/* End Business */}

      {/* Password */}
      <div className="lg:grid lg:grid-cols-3 lg:gap-2 items-center">
        <div className="lg:col-span-1">
          <h3 className="font-primary text-profile-settings-label-mobile lg:text-profile-settings-label leading-6">Password</h3>
        </div>
        <div className="lg:col-span-2">
          <div className="col-span-6 xl:col-span-3">
            <a 
              className="border-b-2 cursor-pointer"
              onClick={initiateResetPassword}
            >
              {formData.password}
            </a>
          </div>
        </div>
      </div>
      {/* End Business */}

    </div>
  )
}

const ProfileSettings = () => {
  const [ user, userDispatch ] = useUser();
  const [ open, setOpen ] = useState(false);

  return (
    <Transition.Root show={user.showProfile} as={Fragment}>
      <Dialog as="div" className="fixed z-55 inset-0 overflow-y-auto" onClose={() => userDispatch({ type: 'profile/close' })}>
        <div className="flex min-h-screen text-center md:block md:px-2 lg:px-4" style={{ fontSize: 0 }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="hidden fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity md:block" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden md:inline-block md:align-middle md:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
            enterTo="opacity-100 translate-y-0 md:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 md:scale-100"
            leaveTo="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
          >
            <div className="flex text-base text-left transform transition w-full md:inline-block md:w-8/12 lg:w-6/12 md:px-4 md:my-8 md:align-middle">
              <div className="w-full rounded-2xl relative flex flex-col bg-white px-4 pt-14 pb-8 overflow-hidden shadow-2xl sm:px-6 sm:pt-8 md:p-6 lg:p-8">
                <div className="px-4 sm:px-6">
                  <div className="flex items-start justify-between">
                    <Dialog.Title className="text-lg font-medium text-gray-900"></Dialog.Title>
                    <div className="ml-3 h-7 flex items-center">
                      <button
                        type="button"
                        className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={ () => userDispatch({ type: 'profile/close' }) }
                      >
                        <span className="sr-only">Close panel</span>
                        <XIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>

                <Dialog.Title className="text-center lg:text-left font-subtitle text-profile-settings-title">Profile Settings</Dialog.Title>

                <div className="flex-1 mt-4 flex flex-col">
                  <div className="mb-4 font-subtitle text-center lg:text-left text-subtitle-mobile text-grey-light lg:text-subtitle">
                    Click any field to update your profile information.
                  </div>

                  <Seperator />

                  <ProfileForm />

                </div>                 
              </div>
            </div>
          </Transition.Child></div>
        </Dialog>
      </Transition.Root>
  );
}

export default ProfileSettings;
